import React from "react";
import "./styles.scss";
import PostHeader from "./PostHeader";
import PostBody from "./PostBody";
import Actions from "../../shared/Actions";

export default props => {
  return (
    <div className={`post ${props.className}`}>
      <PostHeader post={props.post} postsDeleter={props.postsDeleter} />
      <PostBody post={props.post} postSetter={props.setPost} />
      {props.showActions && (
        <Actions
          refresh={props.refresh}
          object={props.post}
          setObject={props.setPost}
        />
      )}
    </div>
  );
};
